module.exports = __webpack_public_path__ + "img/stop.f760f99f.svg";